import { ProductCode } from './product.model';

export const CREDIT_PUBLICATION_DAYS_OVERRIDES: Partial<Record<ProductCode, number>> = {
  [ProductCode.JOBSOFFER22XS]: 31,
  [ProductCode.JOBUP24LITE]: 30,
};
